// DS: i7.24
import React from 'react';
import IconWrap from '../../IconWrap';
const EditorParagraph = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M18.01 4.5c.546 0 .99.448.99 1s-.444 1-.99 1h-1.586v12c0 .552-.443 1-.99 1a.995.995 0 01-.99-1v-12h-2.312v12c0 .552-.444 1-.99 1a.995.995 0 01-.991-1v-3.335C7.294 15.095 5 12.735 5 9.833 5 6.888 7.365 4.5 10.283 4.5h7.726zm-7.86 8.664V6.503c-1.762.07-3.169 1.534-3.169 3.33s1.407 3.26 3.17 3.331z",
        clipRule: "evenodd"
    })));
};
EditorParagraph.displayName = 'EditorParagraph';
export default EditorParagraph;

//# sourceMappingURL=EditorParargraph.js.map